'use strict';

define(['providers/html5', 'providers/flash', 'providers/videojs'], function (html5, flash, videojs) {

    var Store = {
        html5: html5,
        flash: flash,
        videojs: videojs
    };

    return Store;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/providers/providers-loaded.js
 ** module id = 76
 ** module chunks = 0
 **/